var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLogo = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 264.8 258",
    style: {
      enableBackground: "new 0 0 264.8 258"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M124.4,257.1c38.8-62.3,77.2-124,116.2-186.5c-33.7,0-66.3,0-99.4,0c0.4-1.4,0.5-2.3,0.9-3c10.3-20.8,20.6-41.6,30.8-62.4 c1.3-2.6,2.6-3.3,5.5-2.1c41.2,16.3,69,45.4,80.7,88.2c12.4,45.7,2.4,87.3-28.8,122.9c-21.8,24.9-49.9,38.8-82.8,42.4 c-6.7,0.7-13.4,0.6-20.1,0.9C126.5,257.5,125.8,257.3,124.4,257.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8,248.2C40.5,231.5,3.3,186.3,2,128.4C0.8,72.5,36.5,27.3,73.1,9.7C57.4,49.3,41.9,88.6,26,128.6c31,0,61.2,0,92.2,0 C106.9,168.9,95.9,208.5,84.8,248.2z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo.920b1460.svg";
export { ForwardRef as ReactComponent };